// Strips local-only bookkeeping fields from a report before it is sent to the
// create endpoint (kept as a small util after SavedReportsService was removed).
function sanitizeReport (aReport) {
  const report = Object.assign({}, aReport)

  if (report.localId) {
    delete report.localId
  }

  if (report.imageUrl) {
    delete report.imageUrl
  }

  if (report.imageType) {
    delete report.imageType
  }

  return report
}

export {
  sanitizeReport
}
